import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SmoothCollapse from 'react-smooth-collapse';
import CopyButton from '../CopyButton';
import Button from '../Button';
import CodeBlock from '../CodeBlock';
export default class CodeExample extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: this.props.initialOpen,
        };
    }
    render() {
        const { code } = this.props;
        return (React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'col-md-12', style: { paddingTop: '10px' } },
                React.createElement(SmoothCollapse, { expanded: this.state.open },
                    React.createElement(CodeBlock, { code: code })),
                React.createElement("div", { className: 'clearfix' },
                    React.createElement(Button, { variant: 'link', onClick: () => this.setState(prevState => ({ open: !prevState.open })), className: 'pull-right' }, this.state.open ? 'Hide code' : 'Show code'),
                    this.state.open
                        ? (React.createElement(CopyButton, { style: { marginRight: '9px' }, variant: 'link', className: 'pull-right' }))
                        : null))));
    }
}
CodeExample.propTypes = {
    code: PropTypes.string,
    initialOpen: PropTypes.bool,
};
CodeExample.defaultProps = {
    initialOpen: true,
};
